const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const formatMessage = require('format-message');
const SensorPeripheral = require('../common/sensor-peripheral');
const { default: bleUtils } = require('../../util/ble');
const { BLE_CONFIG } = require('../../util/bleCharac');

/**
 * YM-BDGPS 按键传感器模块
 * 
 * @readonly
 */
const DEVICE_OPT = {
    type: 'sensor'
};

/**
 * Manage communication with a YM-BDGPS peripheral over a Scratch Link client socket.
 */
class YMGNSSPeripheral extends SensorPeripheral {
    constructor(runtime, deviceId, originalDeviceId) {
        super(runtime, deviceId, originalDeviceId, null, BLE_CONFIG, DEVICE_OPT);
    }
}

class ScratchYMGNSSDevice {

    get DEVICE_ID() {
        return 'YMGNSS';
    }

    constructor(runtime, originalDeviceId) {
        this.runtime = runtime;
        this._peripheral = new YMGNSSPeripheral(this.runtime, this.DEVICE_ID, originalDeviceId);
        this.bleUtils = new bleUtils();
        
        // this._setupNotifyHandlers();
         //  添加：是否正在连接或已连接
         this._connectionLock = false;
         this._connectionPromise = null;
    }

    getInfo() {
        return [{
            id: 'YMGNSS',
            name: formatMessage({
                id: 'YMGNSS.categoryName',
                default: 'YM GNSS',
                description: 'Label for the YM GNSS extension category'
            }),
            color1: "#002244",
            color2: "#6DB14D",
            color3: "#64A23C",
            blocks: [
                {
                    opcode: 'connect',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YMGNSS.ble.connect',
                        default: 'connect to YM-GNSS-[DEVICE_NAME]',
                        description: 'Connect to YM GNSS'
                    }),
                    arguments: {
                        DEVICE_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: ' ',
                        }
                    }
                },
                {
                    opcode: 'disConnect',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YMGNSS.ble.disconnect',
                        default: 'disconnect from YM GNSS',
                        description: 'Disconnect from YM GNSS'
                    })
                },
                {
                    opcode: 'getLon',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YMGNSS.getLon',
                        default: 'get lon',
                        description: 'Get the lon by gps'
                    })
                },
                {
                    opcode: 'getLat',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YMGNSS.getLat',
                        default: 'get lat',
                        description: 'Get the lat by gps'
                    })
                },
                {
                    opcode: 'getAltitude',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YMGNSS.getAltitude',
                        default: 'get altitude',
                        description: 'Get the altitude from GPS'
                    })
                },
                {
                    opcode: 'getLonStr',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YMGNSS.getLonStr',
                        default: 'get lon str',
                        description: 'Get the lon by gps'
                    })
                },
                {
                    opcode: 'getLatStr',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YMGNSS.getLatStr',
                        default: 'get lat str',
                        description: 'Get the lat by gps'
                    })
                },
                {
                    opcode: 'getAltitudeStr',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YMGNSS.getAltitudeStr',
                        default: 'get altitude str',
                        description: 'Get the altitude from GPS'
                    })
                },
                {
                    opcode: 'getSatellitesStr',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YMGNSS.getSatellitesStr',
                        default: 'get total satellites str',
                        description: 'Get total satellite count'
                    })
                },
                {
                    opcode: 'getAcceleration',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YMGNSS.getAcceleration',
                        default: 'get acceleration',
                        description: 'Get the acceleration from GPS'
                    })
                },
                {
                    opcode: 'getSpeed',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YMGNSS.getSpeed',
                        default: 'get speed',
                        description: 'Get the speed from GPS'
                    })
                },
                {
                    opcode: 'getAngleOfMotion',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YMGNSS.getAngleOfMotion',
                        default: 'get angle of motion',
                        description: 'Get the angle of motion from GPS'
                    })
                },
                {
                    opcode: 'getPositionStatus',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YMGNSS.getPositionStatus',
                        default: 'get position status',
                        description: 'Get the position status'
                    })
                },
                {
                    opcode: 'getAllSatelliteInfo',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YMGNSS.getAllSatelliteInfo',
                        default: 'get all satellite info',
                        description: 'Get all satellite information'
                    })
                },
                {
                    opcode: 'ym_gnss2json',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YMGNSS.ym_gnss2json',
                        default: 'gnss to json lat [LAT] lon [LON] alt [ALT] sat [SAT] buffer [BUFFER]',
                        description: 'Convert GNSS data to JSON format'
                    }),
                    arguments: {
                        LAT: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0
                        },
                        LON: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0
                        },
                        ALT: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0
                        },
                        SAT: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0
                        },
                        BUFFER: {
                            type: ArgumentType.STRING,
                            defaultValue: 'gnss_json_buff'
                        }
                    }
                },
                // 在 getInfo() 的 blocks 数组中，替换原有的积木定义
                {
                    opcode: 'getTotalSatellites',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YMGNSS.getTotalSatellites',
                        default: 'get total satellites',
                        description: 'Get total satellite count'
                    })
                },
                {
                    opcode: 'getBeidouSatellites',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YMGNSS.getBeidouSatellites',
                        default: 'get beidou satellites',
                        description: 'Get beidou satellite count'
                    })
                },
                {
                    opcode: 'getGpsSatellites',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YMGNSS.getGpsSatellites',
                        default: 'get gps satellites',
                        description: 'Get gps satellite count'
                    })
                },
                {
                    opcode: 'calculateDistance',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YMGNSS.calculateDistance',
                        default: 'calculate distance between current point [LAT], [LON] and remote point [REMOTE_LAT], [REMOTE_LON]',
                        description: 'Calculate GNSS distance between two points'
                    }),
                    arguments: {
                        LAT: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0.0
                        },
                        LON: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0.0
                        },
                        REMOTE_LAT: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0.0
                        },
                        REMOTE_LON: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0.0
                        }
                    }
                },
                {
                    opcode: 'jsonToGnss',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YMGNSS.jsonToGnss',
                        default: 'parse gnss from json ',
                        description: 'Parse GNSS data from JSON string'
                    })
                },
                {
                    opcode: 'getRemoteAlt',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YMGNSS.getRemoteAlt',
                        default: 'get remote altitude  ',
                        description: 'Get altitude from GNSS pointer'
                    })
                },
                {
                    opcode: 'getRemoteLat',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YMGNSS.getRemoteLat',
                        default: 'get remote latitude',
                        description: 'Get latitude from GNSS pointer'
                    })
                },
                {
                    opcode: 'getRemoteLon',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YMGNSS.getRemoteLon',
                        default: 'get remote longitude ',
                        description: 'Get longitude from GNSS pointer'
                    })
                },
                {
                    opcode: 'getRemoteSat',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YMGNSS.getRemoteSat',
                        default: 'get remote satellite count',
                        description: 'Get satellite count from GNSS pointer'
                    })
                },
                {
                    opcode: 'formatLocationString',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YMGNSS.formatLocationString',
                        default: 'format location string  [VAL]  [TEXT] lat [LAT] lon [LON] alt [ALT] sat [SAT]',
                        description: 'Format location string with sprintf'
                    }),
                    arguments: {
                        VAL: {
                            type: ArgumentType.STRING,
                            defaultValue: 'local_buff'
                        },
                        TEXT: {
                            type: ArgumentType.STRING,
                            defaultValue: 'RMT'
                        },
                        LAT: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0.0
                        },
                        LON: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0.0
                        },
                        ALT: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0.0
                        },
                        SAT: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0
                        }
                    }
                }
            ],
            menus: {}
        }];
    }

/**
     * Connect to YM-BDGPS device
     * @param {object} args - { DEVICE_NAME }
     */
async connect(args) {
    const deviceName = 'YM-GNSS-' + (args.DEVICE_NAME?.trim() || "");

    // 🔒 如果已经在连接流程中，直接返回已有 promise
    if (this._connectionPromise) {
        console.log(`Connection already in progress or completed. Skipping duplicate connect for ${deviceName}`);
        return await this._connectionPromise;
    }

    // 🔒 创建一个连接 promise 并缓存，防止后续调用再次触发 requestDevice
    this._connectionPromise = this._doConnect(deviceName).catch(err => {
        console.error('Connection failed:', err);
        // 失败后允许重试（可选）：若想禁止重试，则不清理 _connectionPromise
        // this._connectionPromise = null;
    });

    return await this._connectionPromise;
}
 /**
     * 实际执行连接逻辑（仅执行一次）
     */
 async _doConnect(deviceName) {
    // 再次检查是否已连接（避免 race condition）
    const connected = await this.isConnected();
    if (connected) {
        console.log('Already connected. Skip connection.');
        return true;
    }

    console.log(`Connecting to YM GNSS device: ${deviceName}`);

    try {
        // ✅ 此处调用 bleUtils.connect，假设它封装了 requestDevice
        await this.bleUtils.connect(deviceName, BLE_CONFIG.SERVICE_UUID);
        console.log(`Connected to device: ${deviceName}`);
        //await this._setupNotifyHandlers();
        return true;
    } catch (error) {
        // 清理状态，允许用户手动重试
        this._connectionPromise = null;
        throw error; // 抛出错误以便上层处理
    }
}
    async isConnected() {
        return this.bleUtils.device !== null && this.bleUtils.device.gatt.connected;
    }

    async disConnect() {
        if (this.bleUtils.device) {
            try {
                await this.bleUtils.disConnect(this.bleUtils.device);
                console.log('Disconnected from device');
                 // 🔒 断开后释放连接锁，允许重新连接
                 this._connectionPromise = null;
            } catch (error) {
                console.error('Failed to disconnect:', error);
            }
        }
    }

    /**
 * 将GNSS数据转换为JSON格式
 * @param {object} args - 参数对象
 * @param {number} args.LAT - 纬度
 * @param {number} args.LON - 经度
 * @param {number} args.ALT - 海拔
 * @param {number} args.SAT - 卫星数量
 * @param {string} args.BUFFER - JSON缓冲区变量名
 */
ym_gnss2json(args) {
   
    return 0;
}
async getAltitudeStr() {
    const alt = await this.getAltitude();
    return alt;
}
async getSatellitesStr() {
    const sats = await this.getTotalSatellites();
    return sats;
}

/**
 * 获取海拔高度
 * @returns {number} 海拔高度值
 */
async getAltitude() {
    if (!this.bleUtils.device) {
        console.warn('Device not connected');
        return 0;
    }
    
    try {
        const characteristic = await this.bleUtils.getCharacteristic(
            this.bleUtils.service,
            BLE_CONFIG.altitude
        );
        const dataView = await this.bleUtils.readCharacteristic(characteristic);
        
    
        let altitude = '0';
            if (dataView?.buffer instanceof ArrayBuffer) {
                // 解析经度数据
                altitude = new TextDecoder().decode(dataView.buffer);
                altitude = altitude.replaceAll('\u0000','').trim();
            }
        return altitude;
    } catch (error) {
        console.error('Failed to get altitude:', error);
        return 0;
    }
}
/**
 * 获取定位状态
 * @returns {number} 定位状态值
 */
async getPositionStatus() {
    if (!this.bleUtils.device) {
        console.warn('Device not connected');
        return 0;
    }
    
    try {
        const characteristic = await this.bleUtils.getCharacteristic(
            this.bleUtils.service,
            BLE_CONFIG.positionStatus
        );
        const dataView = await this.bleUtils.readCharacteristic(characteristic);
        
        if (dataView?.buffer instanceof ArrayBuffer) {
            // 数值类型数据
            const status = dataView.getUint8(0);
            console.log('Position status:', status);
            return status;
        }
        return 0;
    } catch (error) {
        console.error('Failed to get position status:', error);
        return 0;
    }
}
async getLonStr() {
    const lon = await this.getLon();
    return lon;
}
/**
 * 获取经度
 * @returns {number} 经度
 */
async getLon() {
    if (!this.bleUtils.device) {
        console.warn('Device not connected');
        return 0;
    }
    
    try {
        const characteristic = await this.bleUtils.getCharacteristic(
            this.bleUtils.service,
            BLE_CONFIG.lon
        );
        const dataView = await this.bleUtils.readCharacteristic(characteristic);
        
    
        let longitude = '0';
            if (dataView?.buffer instanceof ArrayBuffer) {
                // 解析经度数据
                longitude = new TextDecoder().decode(dataView.buffer);
                longitude = longitude.replaceAll('\u0000','').trim();
                // console.log('Longitude:', longitude, longitude.length);
            }
        return longitude;
    } catch (error) {
        console.error('Failed to get lon:', error);
        return 0;
    }
}
async getLatStr() {
    const lat = await this.getLat();
    return lat;
}
/**
 * 获取维度
 * @returns {number} 维度
 */
async getLat() {
    if (!this.bleUtils.device) {
        console.warn('Device not connected');
        return 0;
    }
    
    try {
        const characteristic = await this.bleUtils.getCharacteristic(
            this.bleUtils.service,
            BLE_CONFIG.lat
        );
        const dataView = await this.bleUtils.readCharacteristic(characteristic);
        
    
        let latitude = '0';
            if (dataView?.buffer instanceof ArrayBuffer) {
                // 解析经度数据
                latitude = new TextDecoder().decode(dataView.buffer);
                latitude = latitude.replaceAll('\u0000','').trim();
                // console.log('Latitude:', latitude, latitude.length);
            }
        return latitude;
    } catch (error) {
        console.error('Failed to get lat:', error);
        return 0;
    }
}
/**
 * 获取维度
 * @returns {number} 维度
 */
async getSpeed() {
    if (!this.bleUtils.device) {
        console.warn('Device not connected');
        return 0;
    }
    
    try {
        const characteristic = await this.bleUtils.getCharacteristic(
            this.bleUtils.service,
            BLE_CONFIG.speed
        );
        const dataView = await this.bleUtils.readCharacteristic(characteristic);
        
    
        let speed = '0';
            if (dataView?.buffer instanceof ArrayBuffer) {
                // 解析经度数据
                speed = new TextDecoder().decode(dataView.buffer);
            }
        return speed;
    } catch (error) {
        console.error('Failed to get lat:', error);
        return 0;
    }
}

async getAcceleration() {
    if (!this.bleUtils.device) {
        console.warn('Device not connected');
        return 0;
    }
    
    try {
        const characteristic = await this.bleUtils.getCharacteristic(
            this.bleUtils.service,
            BLE_CONFIG.gps_acceleration
        );
        const dataView = await this.bleUtils.readCharacteristic(characteristic);
        
    
        let acceleration = '0';
            if (dataView?.buffer instanceof ArrayBuffer) {
                // 解析经度数据
                acceleration = new TextDecoder().decode(dataView.buffer);
            }
        return acceleration;
    } catch (error) {
        console.error('Failed to get acceleration:', error);
        return 0;
    }
}
async getAngleOfMotion() {
    if (!this.bleUtils.device) {
        console.warn('Device not connected');
        return 0;
    }
    
    try {
        const characteristic = await this.bleUtils.getCharacteristic(
            this.bleUtils.service,
            BLE_CONFIG.angleOfMotion
        );
        const dataView = await this.bleUtils.readCharacteristic(characteristic);
        
    
        let angleOfMotion = '0';
            if (dataView?.buffer instanceof ArrayBuffer) {
                // 解析经度数据
                angleOfMotion = new TextDecoder().decode(dataView.buffer);
            }
        return angleOfMotion;
    } catch (error) {
        console.error('Failed to get acceleration:', error);
        return 0;
    }
}

/**
 * 获取总卫星数
 */
async getTotalSatellites() {
    if (!this.bleUtils.device) {
        console.warn('Device not connected');
        return 0;
    }
    
    try {
        const characteristic = await this.bleUtils.getCharacteristic(
            this.bleUtils.service,
            BLE_CONFIG.satelilitesNo
        );
        const dataView = await this.bleUtils.readCharacteristic(characteristic);
        
        if (dataView?.buffer instanceof ArrayBuffer) {
            return dataView.getUint8(0);
        }
        return 0;
    } catch (error) {
        console.error('Failed to get total satellites:', error);
        return 0;
    }
}

/**
 * 获取北斗卫星数
 */
async getBeidouSatellites() {
    if (!this.bleUtils.device) {
        console.warn('Device not connected');
        return 0;
    }
    
    try {
        const characteristic = await this.bleUtils.getCharacteristic(
            this.bleUtils.service,
            BLE_CONFIG.beidouSatellitesNo
        );
        const dataView = await this.bleUtils.readCharacteristic(characteristic);
        
        if (dataView?.buffer instanceof ArrayBuffer) {
            return dataView.getUint8(0);
        }
        return 0;
    } catch (error) {
        console.error('Failed to get beidou satellites:', error);
        return 0;
    }
}

/**
 * 获取GPS卫星数
 */
async getGpsSatellites() {
    if (!this.bleUtils.device) {
        console.warn('Device not connected');
        return 0;
    }
    
    try {
        const characteristic = await this.bleUtils.getCharacteristic(
            this.bleUtils.service,
            BLE_CONFIG.gpsSatellitesNo
        );
        const dataView = await this.bleUtils.readCharacteristic(characteristic);
        
        if (dataView?.buffer instanceof ArrayBuffer) {
            return dataView.getUint8(0);
        }
        return 0;
    } catch (error) {
        console.error('Failed to get gps satellites:', error);
        return 0;
    }
}
    /**
 * 获取卫星信息
 * @param {object} args - { INFO_TYPE }
 */
async getSatelliteInfo(args) {
    if (!this.bleUtils.device) {
        console.warn('Device not connected');
        return 0;
    }
    
    try {
        let characteristic;
        let charUuid;
        
        switch(args.INFO_TYPE) {
            case 'total':
                charUuid = BLE_CONFIG.satelilitesNo;
                break;
            case 'beidou':
                charUuid = BLE_CONFIG.beidouSatellitesNo;
                break;
            case 'gps':
                charUuid = BLE_CONFIG.gpsSatellitesNo;
                break;
            case 'time':
                charUuid = BLE_CONFIG.gps_time;
                break;
            case 'status':
                charUuid = BLE_CONFIG.positionStatus;
                break;
            default:
                return 0;
        }
        
        characteristic = await this.bleUtils.getCharacteristic(
            this.bleUtils.service,
            charUuid
        );
        
        // 启用通知以获取数据
        let result = null;
        const dataView = await this.bleUtils.readCharacteristic(characteristic);
        
        if (args.INFO_TYPE === 'time' || args.INFO_TYPE === 'status') {
            // 字符串类型数据
            result = new TextDecoder().decode(dataView.buffer);
        } else {
            
            // 数值类型数据
            result = dataView.getUint8(0);
            
        }
    
        console.log(args.INFO_TYPE+","+result);
        return result || 0;
    } catch (error) {
        console.error('Failed to get satellite info:', error);
        return 0;
    }
}
    /**
 * 获取所有卫星信息
 */
async getAllSatelliteInfo() {
    if (!this.bleUtils.device) {
        console.warn('Device not connected');
        return '{}';
    }
    
    try {
        const info = {};
        
        // 依次读取各项信息
        info.total = await this.getSatelliteInfo({INFO_TYPE: 'total'});
        info.beidou = await this.getSatelliteInfo({INFO_TYPE: 'beidou'});
        info.gps = await this.getSatelliteInfo({INFO_TYPE: 'gps'});
        info.time = await this.getSatelliteInfo({INFO_TYPE: 'time'});
        info.status = await this.getSatelliteInfo({INFO_TYPE: 'status'});
        
        return JSON.stringify(info);
    } catch (error) {
        console.error('Failed to get all satellite info:', error);
        return '{}';
    }
}

/**
 * 计算两点之间的距离
 * @param {object} args - 参数对象
 * @param {number} args.LAT - 当前纬度
 * @param {number} args.LON - 当前经度
 * @param {number} args.REMOTE_LAT - 远程纬度
 * @param {number} args.REMOTE_LON - 远程经度
 * @returns {string} 生成的C代码字符串
 */
calculateDistance(args) {
    return "";
}

/**
 * 将JSON数据解析为GNSS结构体
 * @param {object} args - 参数对象
 * @param {string} args.JSON_DATA - JSON数据
 * @returns {string} 生成的C代码字符串
 */
jsonToGnss(args) {
    return "";
}

/**
 * 从GNSS指针获取远程海拔
 * @param {object} args - 参数对象
 * @param {string} args.GNSS_POINTER - GNSS指针变量名
 * @returns {string} 生成的C代码字符串
 */
getRemoteAlt(args) {
    return "";
}

/**
 * 从GNSS指针获取远程纬度
 * @param {object} args - 参数对象
 * @param {string} args.GNSS_POINTER - GNSS指针变量名
 * @returns {string} 生成的C代码字符串
 */
getRemoteLat(args) {
    return "";
}

/**
 * 从GNSS指针获取远程经度
 * @param {object} args - 参数对象
 * @param {string} args.GNSS_POINTER - GNSS指针变量名
 * @returns {string} 生成的C代码字符串
 */
getRemoteLon(args) {
    return "";
}

/**
 * 从GNSS指针获取远程卫星数
 * @param {object} args - 参数对象
 * @param {string} args.GNSS_POINTER - GNSS指针变量名
 * @returns {string} 生成的C代码字符串
 */
getRemoteSat(args) {
    return "";
}

/**
 * 格式化位置字符串
 * @param {object} args - 参数对象
 * @param {string} args.TOPIC - 主题名称
 * @param {number} args.LAT - 纬度
 * @param {number} args.LON - 经度
 * @param {number} args.ALT - 海拔
 * @param {number} args.SAT - 卫星数
 * @returns {string} 生成的C代码字符串
 */
formatLocationString(args) {
    
    return "";
}


}

module.exports = ScratchYMGNSSDevice;
